(() => {
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!finePointer.matches || reduceMotion.matches) return;

  const selector = '.button, .header-wrapper, .sil-compare__handle, .sil-category-link__title, .sil-header-search';
  let frame = 0;
  let event;

  document.addEventListener('pointermove', (nextEvent) => {
    const target = nextEvent.target.closest?.(selector);
    if (!target) return;
    event = nextEvent;
    if (frame) return;
    frame = requestAnimationFrame(() => {
      const rect = target.getBoundingClientRect();
      target.style.setProperty('--sil-glass-x', `${event.clientX - rect.left}px`);
      target.style.setProperty('--sil-glass-y', `${event.clientY - rect.top}px`);
      frame = 0;
    });
  }, { passive: true });
})();
